var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ backgroundColor: 'rgba(255, 255, 255, 0.5)', position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 })})}
var staticRenderFns = []

export { render, staticRenderFns }